import { render } from "./loader.vue?vue&type=template&id=7e30a07a&ts=true"
import script from "./loader.vue?vue&type=script&lang=ts"
export * from "./loader.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__